import { defineComponent } from '@nuxtjs/composition-api';

const __default__ = defineComponent({
  head: {
    script: [
      {
        src: 'https://cdn.jsdelivr.net/gh/web-chats/canyon@main/twilio-chat-prestigio-solutions.bundle.js',
        defer: true,
      },
    ],
  },
});

import { onMounted } from 'vue';


export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'ChatBot',
  setup(__props) {

const initTwilioChat = () => {
  if (!window.Twilio || typeof window.Twilio.initWebchat !== 'function') {
    console.error(
      '❌ Twilio.initWebchat not found. Please check your build or bundle URL.',
    );
    return;
  }

  try {
    window.Twilio.initWebchat({
      serverUrl: 'https://daemonflow.com',
      theme: { isLight: true },
    });
    console.log(' Webchat initialized successfully.');
  } catch (e) {
    console.error(' Failed to initialize Twilio Webchat:', e);
  }
};

onMounted(() => {
  setTimeout(() => initTwilioChat(), 2000);
});

return { __sfc: true,initTwilioChat }
}

})